import React, { useEffect, useMemo, FC } from "react";
import { ProductViewModel } from "../../models";

interface IProps {
	product: any
}

const ProductDetail: FC<IProps> = React.memo((props) => {
	const { product } = props;

	const productVM = new ProductViewModel(product);
	console.log('product: ', product);

	return (
		<div className="w-100">
			<div className="main">
				<div className="container">
					<div className="d-flex align-items-center product-summary">
						<div className="product-thumb d-flex align-item-center">
							<img style={{ objectFit: 'contain' }} src={product.imageUrls && product.imageUrls[0]} className="img-fluid" />
							{/* {
                            Object.keys(product).length !== 0 ? 
                            
                            : <div></div>
                        } */}

						</div>
						<strong>{product.name}</strong>
					</div>
					<h5>Thông tin sản phẩm</h5>
					<div className="product-detail">
						<div>
							{
								productVM.getViewDetailInfo().map((info, index) => {
									return <>
										<b>{index + 1}. {info.title}: </b>
										<p>
											<div dangerouslySetInnerHTML={{ __html: info.value }} />
										</p>
									</>
								})
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});

export default ProductDetail;
